import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Headphones } from "lucide-react";
import SEO from "@/components/SEO";

const CATEGORIES = ["all", "Tax Debt Solutions", "Creative Financing", "Foreclosure", "Investor Playbooks"];

export default function Catalog() {
  const [books, setBooks] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    const url = cat === "all" ? "/ebooks" : `/ebooks?category=${encodeURIComponent(cat)}`;
    api.get(url).then((r) => setBooks(r.data)).catch(() => setBooks([]));
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16" data-testid="catalog-page">
      <SEO
        title="Ebook Catalog"
        description="Browse Aperture Enterprises' full catalog of creative real estate playbooks: tax debt solutions, creative financing, foreclosure workouts, and investor strategies."
        canonical="https://apertureent.com/catalog"
      />
      <div className="mb-14">
        <div className="eyebrow mb-3">The Full Library</div>
        <h1 className="aperture-h1 text-5xl md:text-6xl">Catalog.</h1>
      </div>

      <div className="flex flex-wrap gap-2 mb-14 border-b border-navy-10 pb-4" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        {CATEGORIES.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`cat-${c.replace(/\s+/g,"-").toLowerCase()}`}
            className={`px-5 py-2 text-xs uppercase tracking-widest transition-colors duration-300 rounded-sm ${cat === c ? "bg-navy text-white" : "text-navy hover:text-gold"}`}>
            {c === "all" ? "All" : c}
          </button>
        ))}
      </div>

      {books.length === 0 ? (
        <div className="text-navy/50 py-24 text-center" data-testid="catalog-empty">No ebooks in this category yet.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12">
          {books.map((b) => (
            <Link key={b.id} to={`/ebook/${b.slug}`} data-testid={`ebook-card-${b.slug}`} className="book-card group">
              <div className="relative aspect-[3/4] bg-[#F7F5F0] overflow-hidden shadow-xl rounded-sm flex items-center justify-center p-4">
                <img src={b.cover_image_url} alt={b.title} className="max-w-full max-h-full w-auto h-auto object-contain" />
                {b.has_audio && (
                  <span data-testid={`audio-badge-${b.slug}`} className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-1 rounded-sm bg-navy text-white text-[9px] uppercase tracking-widest shadow-md">
                    <Headphones className="w-2.5 h-2.5" strokeWidth={2}/> Audio
                  </span>
                )}
              </div>
              <div className="mt-5">
                <div className="eyebrow mb-1.5">{b.category}</div>
                <div className="font-serif text-lg text-navy leading-tight">{b.title}</div>
                <div className="mt-2 text-gold text-sm">${b.price.toFixed(2)}{b.has_audio && b.audio_price ? <span className="text-navy/40"> · Audio ${b.audio_price.toFixed(2)}</span> : null}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
